import { render, staticRenderFns } from "./InputOrgNumber.vue?vue&type=template&id=7ea56790"
import script from "./InputOrgNumber.vue?vue&type=script&lang=js"
export * from "./InputOrgNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports